import {
  Grid,
  Typography,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useRef, useEffect, useState } from "react";
import "../../../assets/css/steps.css";
import { Close } from "@mui/icons-material";

const Step_3_Delegation = ({
  delegation,
  errors,
  frontFile,
  setFrontFile,
  backFile,
  setBackFile,
  visuraFile,
  setVisuraFile,
  uploadIdentityDocumentFront,
  uploadIdentityDocumentBack,
  uploadIdentityDocumentVisura,
  setSelectedDocumentType,
  selectedDocumentType,
  deleteDocument,
  setDocumentType,
  getMedia,
  setErrors,
}) => {
  const frontInputRef = useRef();
  const backInputRef = useRef();
  const visuraInputRef = useRef();

  const [initialFrontFile, setInitialFrontFile] = useState(null);
  const [initialBackFile, setInitialBackFile] = useState(null);
  const [initialVisuraFile, setInitialVisuraFile] = useState(null);

  const [isResetting, setIsResetting] = useState(false);

  const removeFieldError = (field) => {
    if (errors.includes(field)) {
      const newErrors = errors.filter((e) => e !== field);
      setErrors(newErrors);
    }
  };

  const truncateFileName = (name, maxLength = 30) => {
    if (name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf(".");
    const ext = extIndex !== -1 ? name.slice(extIndex) : "";
    const truncated = name.slice(0, maxLength - 3 - ext.length);
    return `${truncated}...${ext}`;
  };

  useEffect(() => {
    if (!delegation || isResetting) return;

    if (delegation.identityDocumentFront) {
      setInitialFrontFile({
        name: delegation.identityDocumentFront.split("/").pop(),
        url: `${process.env.REACT_APP_API_ENDPOINT}${delegation.identityDocumentFront}`,
      });
    }

    if (delegation.identityDocumentRear) {
      setInitialBackFile({
        name: delegation.identityDocumentRear.split("/").pop(),
        url: `${process.env.REACT_APP_API_ENDPOINT}${delegation.identityDocumentRear}`,
      });
    }

    if (
      delegation.personType === "JURIDICAL" &&
      delegation.identityDocumentUnique
    ) {
      setInitialVisuraFile({
        name: delegation.identityDocumentUnique.split("/").pop(),
        url: `${process.env.REACT_APP_API_ENDPOINT}${delegation.identityDocumentUnique}`,
      });
    }

    setIsResetting(false);
  }, [delegation, isResetting]);

  useEffect(() => {
    if (delegation) {
      if (delegation.identityDocumentType) {
        setSelectedDocumentType(delegation.identityDocumentType);
      }
    }
  }, [delegation]);

  const handleFileChangeAndUpload = (setter, uploadFunc) => async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    setter(file);

    try {
      await uploadFunc([file]);
    } catch (error) {
      console.error("Errore", error);
    }
  };

  const handleRemoveFile =
    (setter, inputRef, initialSetter, typeDelete) => async () => {
      setter(null);
      initialSetter(null);
      if (inputRef.current) inputRef.current.value = null;
      deleteDocument(typeDelete);
    };

  const cleanDocumentUpload = () => {
    setIsResetting(true);
    setFrontFile(null);
    setBackFile(null);
    setVisuraFile(null);
    setInitialFrontFile(null);
    setInitialBackFile(null);
    setInitialVisuraFile(null);

    if (frontInputRef.current) frontInputRef.current.value = null;
    if (backInputRef.current) backInputRef.current.value = null;
    if (visuraInputRef.current) visuraInputRef.current.value = null;

    deleteDocument("identityDocumentFront");
    deleteDocument("identityDocumentRear");
    deleteDocument("identityDocumentUnique");
  };

  const hasError = (name) => errors.includes(name);

  const renderFileInputBlock = ({
    label,
    file,
    initialFile,
    inputRef,
    onClick,
    onRemove,
    onChange,
    errorKey,
  }) => (
    <Grid item>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          width: "220px",
        }}
      >
        <input
          type="file"
          accept="image/*,application/pdf"
          style={{ display: "none" }}
          ref={inputRef}
          onChange={async (event) => {
            removeFieldError(errorKey);
            await onChange(event);
          }}
        />

        <Button
          onClick={onClick}
          variant="outlined"
          className={
            hasError(errorKey)
              ? "button-bg-empty-document-error"
              : "button-bg-empty-document"
          }
          style={{
            width: "220px",
            padding: "7px 5px",
          }}
        >
          <Typography
            className="color-grey"
            sx={{
              textTransform: "initial",
              fontSize: { xs: "14px", sm: "16px" },
              fontWeight: 500,
            }}
          >
            {label}
          </Typography>
        </Button>

        {(file || initialFile) && (file !== null || initialFile !== null) && (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              marginTop: "10px",
            }}
          >
            <Typography
              component="span"
              onClick={() => {
                if (initialFile) {
                  getMedia(initialFile.url);
                } else if (file) {
                  getMedia(file);
                }
              }}
              sx={{
                fontSize: "14px",
                cursor: "pointer",
                textDecoration: "underline",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "200px",
              }}
            >
              {truncateFileName(file ? file.name : initialFile.name)}
            </Typography>

            <Button
              onClick={onRemove}
              className="color-grey"
              sx={{
                minWidth: "auto",
                padding: "2px",
                marginLeft: "3px",
                backgroundColor: "transparent",
                boxShadow: "none",
                "&:hover": {
                  backgroundColor: "transparent",
                  boxShadow: "none",
                },
              }}
            >
              <Close style={{ color: "#5b5b5b" }} fontSize="small" />
            </Button>
          </div>
        )}
      </div>
    </Grid>
  );

  return (
    <Grid container className="container-steps">
      <Grid item xs={12}>
        <Typography className="title-steps">
          {delegation?.personType === "NATURAL" ? (
            <>Carica il tuo documento di identità</>
          ) : delegation?.personType === "JURIDICAL" ? (
            <>Carica i documenti richiesti</>
          ) : (
            ""
          )}
        </Typography>
        <Typography className="text-steps" sx={{ mt: 1 }}>
          {delegation?.personType === "NATURAL" ? (
            <>
              Il documento verrà da noi allegato alla delega. Puoi scegliere la
              carta di identità o il passaporto.{" "}
              <span style={{ fontWeight: "bold" }}>
                Assicurati che il documento sia in corso di validità
              </span>
              .
            </>
          ) : delegation?.personType === "JURIDICAL" ? (
            <>
              I documenti verranno da noi allegati alla delega. Per il legale
              rappresentante/amministratore puoi scegliere la carta di identità
              o il passaporto.
              <br />
              <span style={{ fontWeight: "bold" }}>
                Assicurati che il documento sia in corso di validità
              </span>
              .
            </>
          ) : (
            ""
          )}
        </Typography>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 3,
          flexWrap: "wrap",
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
          }}
        >
          <RadioGroup
            row
            name="documentType"
            value={selectedDocumentType}
            onChange={(e) => {
              removeFieldError("identityDocumentType");
              const newValue = e.target.value;
              setSelectedDocumentType(newValue);
              setDocumentType(newValue);
              cleanDocumentUpload();
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "10px",
              }}
            >
              <FormControlLabel
                value="CI"
                control={
                  <Radio
                    disableRipple
                    sx={{
                      color: "#5b5b5b",
                      "&.Mui-checked": { color: "#5b5b5b" },
                      "&:hover": { backgroundColor: "transparent" },
                      "&:focus-visible": { outline: "none" },
                      padding: "5px",
                      marginLeft: "2px",
                    }}
                  />
                }
                label="Carta d'identità"
                sx={{
                  "& .MuiRadio-root + span": {
                    color: errors.includes("identityDocumentType")
                      ? "#D32F2F"
                      : "#5b5b5b",
                  },
                }}
              />

              <FormControlLabel
                value="PASSPORT"
                control={
                  <Radio
                    disableRipple
                    sx={{
                      color: "#5b5b5b",
                      "&.Mui-checked": { color: "#5b5b5b" },
                      "&:hover": { backgroundColor: "transparent" },
                      "&:focus-visible": { outline: "none" },
                      padding: "5px",
                      marginLeft: "2px",
                    }}
                  />
                }
                label="Passaporto"
                sx={{
                  "& .MuiRadio-root + span": {
                    color: errors.includes("identityDocumentType")
                      ? "#D32F2F"
                      : "#5b5b5b",
                  },
                }}
              />
            </div>
          </RadioGroup>
        </Grid>

        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: 5,
            flexWrap: "wrap",
          }}
        >
          {delegation?.personType === "NATURAL" && selectedDocumentType && (
            <>
              {renderFileInputBlock({
                label:
                  selectedDocumentType === "PASSPORT"
                    ? "Carica passaporto"
                    : "Carica fronte",
                file: frontFile,
                initialFile: initialFrontFile,
                inputRef: frontInputRef,
                onClick: () => frontInputRef.current.click(),
                onChange: handleFileChangeAndUpload(
                  setFrontFile,
                  uploadIdentityDocumentFront,
                ),
                onRemove: handleRemoveFile(
                  setFrontFile,
                  frontInputRef,
                  setInitialFrontFile,
                  "identityDocumentFront",
                ),
                errorKey: "identityDocumentFront",
              })}

              {selectedDocumentType === "CI" &&
                renderFileInputBlock({
                  label: "Carica retro",
                  file: backFile,
                  initialFile: initialBackFile,
                  inputRef: backInputRef,
                  onClick: () => backInputRef.current.click(),
                  onChange: handleFileChangeAndUpload(
                    setBackFile,
                    uploadIdentityDocumentBack,
                  ),
                  onRemove: handleRemoveFile(
                    setBackFile,
                    backInputRef,
                    setInitialBackFile,
                    "identityDocumentRear",
                  ),
                  errorKey: "identityDocumentRear",
                })}
            </>
          )}

          {delegation?.personType === "JURIDICAL" && selectedDocumentType && (
            <>
              {renderFileInputBlock({
                label:
                  selectedDocumentType === "PASSPORT"
                    ? "Carica passaporto"
                    : "Carica fronte",
                file: frontFile,
                initialFile: initialFrontFile,
                inputRef: frontInputRef,
                onClick: () => frontInputRef.current.click(),
                onChange: handleFileChangeAndUpload(
                  setFrontFile,
                  uploadIdentityDocumentFront,
                ),
                onRemove: handleRemoveFile(
                  setFrontFile,
                  frontInputRef,
                  setInitialFrontFile,
                  "identityDocumentFront",
                ),
                errorKey: "identityDocumentFront",
              })}

              {selectedDocumentType === "CI" &&
                renderFileInputBlock({
                  label: "Carica retro",
                  file: backFile,
                  initialFile: initialBackFile,
                  inputRef: backInputRef,
                  onClick: () => backInputRef.current.click(),
                  onChange: handleFileChangeAndUpload(
                    setBackFile,
                    uploadIdentityDocumentBack,
                  ),
                  onRemove: handleRemoveFile(
                    setBackFile,
                    backInputRef,
                    setInitialBackFile,
                    "identityDocumentRear",
                  ),
                  errorKey: "identityDocumentRear",
                })}

              {delegation?.personType === "JURIDICAL" &&
                selectedDocumentType && (
                  <>
                    <Grid item xs={12}>
                      <Typography
                        className="text-steps"
                        sx={{ mb: 2, mt: "-24px" }}
                      >
                        Carica di seguito la{" "}
                        <span style={{ fontWeight: "bold" }}>
                          visura camerale aggiornata
                        </span>{" "}
                        della tua società.
                      </Typography>
                      {renderFileInputBlock({
                        label: "Carica visura aggiornata",
                        file: visuraFile,
                        initialFile: initialVisuraFile,
                        inputRef: visuraInputRef,
                        onClick: () => visuraInputRef.current.click(),
                        onChange: handleFileChangeAndUpload(
                          setVisuraFile,
                          uploadIdentityDocumentVisura,
                        ),
                        onRemove: handleRemoveFile(
                          setVisuraFile,
                          visuraInputRef,
                          setInitialVisuraFile,
                          "identityDocumentUnique",
                        ),
                        errorKey: "identityDocumentUnique",
                      })}
                    </Grid>
                  </>
                )}
            </>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Step_3_Delegation;
